// i18n
import { translateInComponent } from 'infras/i18n';
import translations from './i18n.json';

import styled from '@emotion/styled';
import {
  borderRadius,
  fontSize,
  isMediaMax,
  mediaMax,
  spacing,
} from 'presentations/views/styles';
import { blueGrayPale } from 'presentations/views/styles/color';

interface Props {
  className?: string;
}

export default function Component(props: Props) {
  const t = translateInComponent(translations);
  const isMobile = isMediaMax('tablet');
  return (
    <Description className={props.className}>
      <span dangerouslySetInnerHTML={{ __html: t('Pro Message 1') }} />
      {!isMobile && <br />}
      <span>{t('Pro Message 2')}</span>
      {/* {!isMobile && <br />}
      <span>{t('Pro Message 3')}</span> */}
    </Description>
  );
}

const Description = styled.div`
  padding: ${spacing(8)} ${spacing(12)};
  background: ${blueGrayPale};
  border-radius: ${borderRadius(6)};
  font-size: ${fontSize(12)};
`;
